import axios, { CancelToken } from 'apis';
import { sessionService } from 'redux-react-session';
import { getThunkActionCreator } from 'redux-thunk-routine';
import {
  getUrgentlyAdditionalCostsRoutine,
  createUrgentlyAdditionalCostRoutine,
  clearLocalUrgentlyAdditionalCostsRoutine
} from 'actions';

const attributes = [
  'id',
  'price',
  'cost_type',
  'formatted_cost_type',
  'minutes',
  'notes',
  'status',
  'decline_reason',
  'originator',
  'created_at'
];

export const getUrgentlyAdditionalCosts = getThunkActionCreator(
  getUrgentlyAdditionalCostsRoutine,
  async ({ order_id, offset = 0, limit = 10 }) => {
    getUrgentlyAdditionalCosts.getUrgentlyAdditionalCostsCancel && getUrgentlyAdditionalCosts.getUrgentlyAdditionalCostsCancel();
    const { token: access_token } = await sessionService.loadSession();

    return await axios.get(`/user/orders/${order_id}/urgently_additional_costs`, {
      params: { 
        access_token, 
        offset, 
        limit: limit, 
        orders: { created_at: 'desc' }, 
        attributes
      },
      cancelToken: new CancelToken(function executor(cancel) { getUrgentlyAdditionalCosts.getUrgentlyAdditionalCostsCancel = cancel })
    });
  }
);

export const createUrgentlyAdditionalCost = getThunkActionCreator(
  createUrgentlyAdditionalCostRoutine,
  async ({ order_id, urgently_additional_cost }) => {
    const { token: access_token } = await sessionService.loadSession();

    return await axios.post(`/user/orders/${order_id}/urgently_additional_costs`, { 
      access_token, 
      urgently_additional_cost, 
      attributes 
    });
  }
);

export const clearLocalUrgentlyAdditionalCosts = getThunkActionCreator(
  clearLocalUrgentlyAdditionalCostsRoutine, 
  async () => {}
);
